import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {CampusDesignCategory} from '../DesignSelector/CampusDesignCategory';
import {CampusDesignCard} from '../DesignSelector/CampusDesignCard';
import {CampusDesignSelector} from '../DesignSelector/CampusDesignSelector';
import {RealCampusFooter} from './RealCampusFooter';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';
import {RealCampusHdr} from './RealCampusHdr';
import { RealCampusFeedback } from './RealCampusFeedback';
import { RealCampusDesignCatItem } from './RealCampusDesignCatItem';
import { ButtonToolbar, Dropdown, DropdownButton, DropdownMenu } from 'react-bootstrap';

const DIVISION: string = 'Campus';

const categoryContainerStyle : CSSProperties = {
    position: 'relative',
    width: '200px',
    height:'500px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 15px',
    textTransform: 'uppercase',
    backgroundColor: '#B4B5B4',
    marginBottom: '15px',
    flexShrink: 0,
    borderRadius:'10px',
};
const smHeadStyle : CSSProperties = {
    position:'relative',
    top:'-50px',
    left:'88px',
    fontFamily:'BarlowMedium',
    color:'#616060',
    letterSpacing:'0.15em'
};


const categoryListStyle : CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingBottom: '5px',
    overflowX: 'hidden',
    overflowY: 'auto',
    lineHeight: '15px',
    height:'500px',
    justifyContent:'center',
    fontfamily:'BarlowMedium'
};

const selectorStyle : CSSProperties = {
    position: 'position',
    display: 'flex',
    zIndex: 2,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-around',
    top:'10%',
};

const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flexGrow: 2,
    overflowY: 'auto',
};
const contentDiv: CSSProperties = {
    display:'flex',
    margin:'60px auto 0px auto',
    width:'90%'
}
const addToProofBtn: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#5E6A74',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Reitam'
}
const designHdr: CSSProperties = {
    fontFamily:"BarlowMedium",
    textTransform:"uppercase",
    fontSize:'25px',
    color:'rgb(97, 96, 96)',
    textAlign:'center'
}
const category: CSSProperties = {
    fontFamily:'Reitam',
    color:'rgb(97, 96, 96)',
    position:'relative',
    top:'25px',
    fontSize:'22px'
}
const submitButton : CSSProperties = {
    width:'125px',
    height:'30px',
    backgroundColor:'#5E6A74',
    margin:'5px auto 0px',
    cursor:'pointer',
    display:'none',
    textAlign:'center',
    fontFamily:"Reitam",
    color:'white',
    lineHeight:'30px',
    padding: '2px 0 2px 0px',
}
const searchStyle : CSSProperties = {
    fontFamily: 'BarlowMedium',
    fontSize: '18px',
    letterSpacing: '6px',
    backgroundColor:'white',
    textAlign: 'center',
    border: '1px solid #CCCCCC',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '350px',
    height:'25px'
};
const inputDiv: CSSProperties = {
    marginTop:'10px',
    display:'flex',
    justifyContent:'center'
}
const cateHdr: CSSProperties = {
    fontFamily:'Lulo',
    fontSize:'18px'
}
const mobileCat: CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'rgb(94, 106, 116)',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    height:'34px',
    fontSize:'18px'

}

type StateType = {
    filter: string,
    category: string,
    design: Tgcc.Design,
    zoomDesign: Tgcc.Design,
    DesignCategories: string[],
    Designs: Tgcc.Design[],
    isWaiting: boolean
}
const designCategory: string = "New Designs"
class _RealCampusDesignListView extends React.Component<Tgcc.BaseProps, any>{


 componentWillMount() {
        document.body.style.overflow = 'hidden';
        this.clearState();
        if(!this.props.state.ActiveProof){
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof()});
        }
        TgccRequest.getDesignCategories(DIVISION, (categories : string[]) => this.DesignCategoriesLoaded(categories));
        TgccRequest.getDesignsByCategoryFiltered(DIVISION, designCategory, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))

    }
 componentDidMount(){
        var designCate = this.props.location.query.designCat;
        console.log("active proof",this.props.state.ActiveProof);
        if(this.props.location.query.designCat != null){
            this.handleFilterByCategory(designCate);
        }
        var tag = document.getElementById('designPage');
        tag.scrollIntoView(false);
 }
 scrollPageToView = (id: string) => {
    var el = document.getElementById(id);
    var scroller = document.getElementById("Scroller");
    scroller.scrollTop = el.offsetTop - 75;
}

    state: StateType = {
        filter: null,
        category: null,
        design: null,
        zoomDesign: null,
        DesignCategories: null,
        Designs: null,
        isWaiting: true
    }

    clearState = () => {
        this.setState({
            filter: null,
            category: null,
            design: null,
            zoomDesign: null,
            DesignCategories: null,
            Designs: null,
            isWaiting:true});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }

    DesignCategoriesLoaded(categories : string[]) {
        this.setState({DesignCategories: categories});
    }

    getDesignCategories() {
        var categories = new Array();
        for (var i in this.state.DesignCategories) {
            var cat: string = this.state.DesignCategories[i];
            categories.push(
                <CampusDesignCategory key={i} text={cat} onChange={this.handleFilterByCategory}></CampusDesignCategory>
            )
        };
        return categories;
    }
    getMobileDesignCategories() {
        var categories = new Array();
        for (var i in this.state.DesignCategories) {
            var cat: string = this.state.DesignCategories[i];
            categories.push(
                <RealCampusDesignCatItem key={i} eventKey={i} category={cat} onClick={this.handleFilterByCategory}/>
            )
        };
        return categories;
    }
   
    handleFilterByCategory = (category: string) =>{
        if(category){
            TgccRequest.getDesignsByCategoryFiltered(DIVISION, category, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        }
        this.setState({category:category});
        if(this.state.isWaiting === false){
            this.setState({isWaiting:true})
        }else {
            this.setState({isWaiting:false});
        }
        var input = document.getElementById('search') as HTMLInputElement;
        input.value = '';
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: category});
    };

    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs,isWaiting:false});
    }

    DesignsVisible: boolean = false;
    getDesignItems() {
        this.DesignsVisible = false;
       
        var Designs = new Array();
        var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center'};

        if(this.state.Designs){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<CampusDesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
            this.DesignsVisible = true;
        } else {
            var chooseSomething = (<div key="none" style={noItemsStyle}>Select a category or search</div>);
            Designs.push(chooseSomething);
        }

        return Designs;
        
    }

    getBackButton(){
        var style : CSSProperties = {
            fontSize: '14px',
            letterSpacing: '3px',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginTop: '10px',
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid tranparent',
            width: '40%',
            cursor: 'pointer',
        };
        return ( <div className="hoverBorder" style={style} onClick={this.handleBackToProof}>back</div>)
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign:design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateRealCampusProofDesign, payload: design});
    }

    selectedImageStyle: CSSProperties = {
         display: 'flex',
         width: '200px',
         alignSelf: 'center',
         cursor: 'zoom-in'
    }


    handleDetailBackButton = () => {
        this.setState( { design: null});
    }
    clearCategory = () =>{
        this.setState({category:null});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }

    filterDesignsBySearch(filter: string){
        filter = filter && filter.length ? filter : null;
        this.setState({filter: filter, Designs: null,category:null});
        this.clearCategory();
        TgccRequest.getDesignsFiltered(DIVISION, filter, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs));
    }
    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value.toLowerCase(); // make sure "" is set to null
        if(this.state.filter != srchComp){
            this.filterDesignsBySearch(srch.value);
        }
    }
    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.keyCode == 13){ // return keyCode
            this.filterDesignsBySearch(evt.currentTarget.value.toLowerCase());
        }

        var style = evt.currentTarget.attributes['style'];
        if(style && style.value){
            if(evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px','letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px','letter-spacing: 6px');
        }
    }
    onSubmit(e){
        e.preventDefault();
    }
    get = () => {
        if(this.state.filter) {
            this.filterDesignsBySearch(this.state.filter.toLowerCase());
        }
    }
    mobileCheck() {
        return (<div style={inputDiv}>
                    <input type="text" ref="search" id="search"style={searchStyle} placeholder="Search Everything" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/>
                </div>)
    }

    render() {
        var searchBlock = this.mobileCheck();
        var categories = this.state.DesignCategories ? this.getDesignCategories() : <Tgcc.LoadingElement />
        var designs = this.state.isWaiting ? <Tgcc.LoadingElement /> : this.getDesignItems() 
        if(window.innerWidth <= 440 ){
            return (
                <div key="1" style={selectorStyle}>
                    <div id='designPage'></div>
                        <RealCampusHdr />
                        <RealCampusFeedback state={this.props.state} />

                        <div style={designHdr}>Search our entire design gallery</div>
                        {searchBlock}
                        <div onClick={this.get} className="srchBtnCampus" style={submitButton}>Submit</div>
                    <ButtonToolbar>
                        <DropdownButton id="real-campus-design" title="Categories">
                        {this.getMobileDesignCategories()}
                        </DropdownButton>
                        <div style={mobileCat}>{this.state.category}</div>
                    </ButtonToolbar>
                        
                        <div style={catalogStyle} className="campusLogStyle">
                            {designs}
                        </div>
                            {this.getZoomedDesign()}

                        <RealCampusFooter state={this.props.state}/>
                    </div>
            )
        }else {
        return (
                    <div key="1" style={selectorStyle}>
                    <div id='designPage'></div>
                        <RealCampusHdr />
                        <RealCampusFeedback state={this.props.state} />

                        <div style={designHdr}>Search our entire design gallery</div>
                        {searchBlock}
                        <div onClick={this.get} className="srchBtnCampus" style={submitButton}>Submit</div>

                    
                        <div style={contentDiv} className="campusDesign2Box">    
                        <div key="2" style={categoryContainerStyle} className="campusCatCont">
                            <h3 style={cateHdr}>CATEGORIES</h3>
                            <div style={categoryListStyle} className="campusCatList">{categories}</div>
                        </div>
                        <div style={catalogStyle} className="campusLogStyle">
                            {designs}
                        </div>
                            {this.getZoomedDesign()}
                        </div>
                        <RealCampusFooter state={this.props.state}/>
                    </div>
                )
                }
    }



    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            }
           
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        var largeImage = Tgcc.getDesignPath(this.state.zoomDesign.image);
        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle} className="fullSizeStyle">
                    <CloseX closeAction={this.hideZoom} />
                    <img src={largeImage} style={imgStyle} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={addToProofBtn} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    hideZoom = () => {
        this.setState({zoomDesign: null});
    }

    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        if(this.props.state.LoginData && this.props.state.UserInfo){
            this.handleDesignSelection(this.state.zoomDesign);
        } else
        {
            browserHistory.push(Tgcc.Routes.CampusRegister)
        }
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}
  
const mapStateToProps = (state : Tgcc.GlobalState ) => {
    return {state:state}
};

export var RealCampusDesignListView = connect(mapStateToProps)(Radium(_RealCampusDesignListView));